import { montserratBold, montserratNormal, montserratSemibold } from '@/assets/fonts/montserrat'
import { howToWork } from '@/helpers/content/id/services/reconciliation-automation/how-to-work'
import gsap from 'gsap'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useRef } from 'react'
import { motion } from "framer-motion"
import { t } from 'i18next'

export default function HowToWork() {
  const [indexChoosed, setindexChoosed] = useState(0)
  const videoRef1 = useRef()
  const videoRef2 = useRef()
  const videoRef3 = useRef()
  const descriptionFade = gsap.timeline()
  const descriptionFadeRef = useRef([])

  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const video = videoRef1.current
    if (video) {
      video.muted = true
      video.play()
    }
    const interval = setInterval(() => {
      // Increment progress by 20% every second until it reaches 100%
      setProgress(prevProgress => prevProgress + 1);
    },75);

    // Clear the interval after 5 seconds

    return () => clearInterval(interval);
  }, [])

  useEffect(() => {
    if (progress >= 100) {
      setindexChoosed(prev => prev >= parseInt(howToWork.length-1)? 0 : prev + 1)
      setProgress(0)
    }
  }, [progress])

  useEffect(() => {
    console.log("index choosed ", indexChoosed)
    const video = videoRef1.current
    const video2 = videoRef2.current
    const video3 = videoRef3.current
    if (video && indexChoosed == 0) {
      video.muted = true
      video.play()
    }else if(video2 && indexChoosed == 1){
      video2.muted = true
      video2.play()
    }else if(video3 && indexChoosed == 2){
      video3.muted = true
      video3.play()
    }
  }, [indexChoosed])


  const handleChangeStep = (index) => {
    console.log("click index",index)
    setindexChoosed(index)
    setProgress(0)
  }
  
  

  return (
    <div className='flex w-full h-full lg:flex-row flex-col relative '>
      <div className='hidden lg:flex lg:container max-w-[1280px] lg:mx-auto w-full h-[624px] px-4 lg:px-8 py-16 justify-center items-center'>
        <div className='flex w-[45%] h-full'>
            <div className='flex w-auto'>
              {
                indexChoosed == 0 && (
                  <motion.video 
                    initial={{opacity:0}}
                    animate = {{opacity: 1, transition:{duration: 1}}}
                    exit={{opacity: 0 }}
                    id="videoRecon" 
                    ref={videoRef1} 
                    src={"/how-to-work/1.mp4"} 
                    autoPlay 
                    loop
                  >

                  </motion.video>
                )
              }
              {
                indexChoosed == 1 && (
                  <motion.video 
                    initial={{opacity:0}}
                    animate = {{opacity: 1, transition:{duration: 1}}}
                    exit={{opacity: 0 }}
                    id="videoRecon" 
                    ref={videoRef2} 
                    src={"/how-to-work/2.mp4"} 
                    autoPlay 
                    loop
                  ></motion.video>
                )
              }
              {
                indexChoosed == 2 && (
                  <motion.video 
                    initial={{opacity:0}}
                    animate = {{opacity: 1, transition:{duration: 1}}}
                    exit={{opacity: 0 }}
                    id="videoRecon" 
                    ref={videoRef3} 
                    src={"/how-to-work/3.mp4"} 
                    autoPlay 
                    loop></motion.video>
                )
              }
            </div>
        </div>
        <div className='flex h-full justify-center pl-[48px] w-full max-w-[600px] flex-col'>
          <p className={`text-blue-primary-500 ${montserratSemibold.className}`}>
            {t('recon_how_to_work_tiny_title')}
          </p>
          <h1 className={`${montserratBold.className} py-3 text-[36px] text-gray-cool-700`}>
            {t('recon_how_to_work_title')}
          </h1>
          <ul className='flex justify-center flex-col w-full h-fit'>
            {
              howToWork.map((val,index) => (
                <li key={index} className='block hover:cursor-pointer pt-4'>
                  <div onClick={() => handleChangeStep(index)} className='w-full flex flex-col h-full'>
                    <div className='w-full flex items-center justify-between'>
                      <p className={`${montserratSemibold.className} text-[24px] text-gray-cool-700`}>
                        {t(val.title)}
                      </p>
                      <div className={`rounded-full ${index == indexChoosed ? "bg-blue-primary-50 text-blue-primary-500" : "bg-gray-cool-100 text-gray-cool-400"} flex justify-center items-center w-3 h-3 p-3 text-sm`}>
                        {index+1}
                      </div>
                    </div>
                    {
                      index == indexChoosed && (
                        <motion.div 
                          exit={{
                            y: -20,
                            opacity: 0,
                            filter: "blur(5px)",
                            transition: { ease: "easeIn", duration: 0.22 }
                          }}
                          initial={{ opacity: 0, y: -15 }}
                          animate={{
                            opacity: 1,
                            y: 0,
                            filter: "blur(0px)",
                            transition: { type: "spring", duration: 0.7 }
                          }}
                          className={`${montserratNormal.className} text-gray-cool-500 pt-1`}
                        >
                            {t(val.description)}
                        </motion.div>
                      )
                    }
                    <div className='pt-4 relative h-full w-full'>
                      <div className='w-full h-[2px] absolute bg-gray-cool-200 -z-10' />
                      <div className='w-full h-[2px] absolute bg-blue-primary-500 z-0' style={{width: `${index == indexChoosed ? progress : 0}%`,transition: 'width 0.1s ease-in-out'}} />
                    </div>
                  </div>
                </li>
              ))
            }
          </ul>
        </div>
      </div>
      <div className='flex w-full flex-col lg:hidden px-4 py-16 md:h-full h-full'>
        <div className='flex lg:hidden flex-col w-full h-fit justify-center md:items-center'>
          <p className={`text-blue-primary-500 ${montserratSemibold.className}`}>
            {t('recon_how_to_work_tiny_title')}
          </p>
          <h1 className={`${montserratBold.className} leading-[120%] md:items-center md:leading-normal py-3 text-[36px] text-gray-cool-700`}>
            {t('recon_how_to_work_title')}
          </h1>
        </div>
        <ul className='lg:hidden w-full h-full flex justify-center items-center flex-col'>
            {
              howToWork.map((val,index) => (
                <li onClick={() => handleChangeStep(index)} className='flex hover:cursor-pointer pb-4 flex-col h-fit w-full'>
                  <div className='flex justify-between pb-6 pt-4 items-center w-full'>
                    <p className={`${montserratSemibold.className} text-[24px] text-gray-cool-700`}>
                      {t(val.title)}
                    </p>
                    <div className={`rounded-full ${index == indexChoosed ? "bg-blue-primary-50 text-blue-primary-500" : "bg-gray-cool-100 text-gray-cool-400"} flex justify-center items-center w-3 h-3 p-3 text-sm`}>
                        {index+1}
                    </div>
                  </div>
                  {
                    indexChoosed == index && (
                      <>
                        <div className='flex w-full justify-center items-center'>
                          <div className='flex w-full justify-center'>
                            <div className='flex w-[80%]'>
                            <motion.video 
                              initial={{opacity:0}}
                              animate = {{opacity: 1, transition:{duration: 1}}}
                              exit={{opacity: 0 }}
                              id="videoRecon" 
                              ref={indexChoosed == 0 ? videoRef1 : indexChoosed == 1 ? videoRef2 : videoRef3} 
                              src={val.link} 
                              autoPlay 
                              loop>

                              </motion.video>
                            </div>
                          </div>
                        </div>
                        <motion.div  
                          exit={{
                            y: -20,
                            opacity: 0,
                            filter: "blur(5px)",
                            transition: { ease: "easeIn", duration: 0.22 }
                          }}
                          initial={{ opacity: 0, y: -15 }}
                          animate={{
                            opacity: 1,
                            y: 0,
                            filter: "blur(0px)",
                            transition: { type: "spring", duration: 0.7 }
                          }}
                          className={`${montserratNormal.className} text-gray-cool-500 pt-6 pb-[14px]`}>
                            {t(val.description)}
                          </motion.div>
                      </>
                    )
                  }
                  <div className={`relative h-full w-full`}>
                      <div className='w-full h-[2px] absolute bg-gray-cool-200 -z-10' />
                      <div className='w-full h-[2px] absolute bg-blue-primary-500 z-0' style={{width: `${index == indexChoosed ? progress : 0}%`,transition: 'width 0.1s ease-in-out'}} />
                    </div>
                </li>
              ))
            }
        </ul>
      </div>
    </div>
  )
}
